import RegisterEmployees from "../features/employees/RegisterEmployees"

const RegisterEmployeesPage = () => {
    return (
        <>
            <RegisterEmployees />
        </>
    )
}

export default RegisterEmployeesPage